/* ATOM LED — ARIA repair (2026-08-02)
 * PageSpeed "Agentic Browsing" fails on "ARIA attributes must conform to valid values"
 * because app-injected tabs (Judge.me) carry aria-controls pointing at IDs that never
 * exist in the DOM. Re-point to a real panel when one exists, otherwise drop the
 * dangling attribute — the standards-correct repair. Theme-owned tabs are never touched.
 */
(function () {
  'use strict';
  var SKIP = /^(?:info-tab-|info-panel-)/;
  var SAFE = /^[A-Za-z][\w.:-]*$/;
  var started = Date.now();
  var timer = null;
  var obs = null;

  function fix(el) {
    var id = el.getAttribute('aria-controls');
    if (!id || !SAFE.test(id) || SKIP.test(id) || SKIP.test(el.id || '')) return;
    if (document.getElementById(id)) return;
    var cut = id.indexOf('_');
    var prefix = cut > 3 ? id.slice(0, cut) : '';
    var panel = prefix ? document.querySelector('[id^="' + prefix + '"]') : null;
    if (panel && panel !== el && panel.id && !SKIP.test(panel.id)) {
      el.setAttribute('aria-controls', panel.id);
    } else {
      el.removeAttribute('aria-controls');
    }
  }

  function run() {
    try {
      var nodes = document.querySelectorAll('[aria-controls]');
      for (var i = 0; i < nodes.length; i++) fix(nodes[i]);
    } catch (e) {}
  }

  function stop() {
    if (obs) { obs.disconnect(); obs = null; }
    if (timer) { clearTimeout(timer); timer = null; }
  }

  function schedule() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () {
      timer = null;
      run();
      if (Date.now() - started > 15000) stop();
    }, 200);
  }

  try {
    run();
    window.addEventListener('load', run, { once: true });
    if (window.requestIdleCallback) window.requestIdleCallback(run);
    obs = new MutationObserver(schedule);
    obs.observe(document.body || document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { run(); stop(); }, 15000);
  } catch (e) {}
})();

